import React, { useEffect, useState } from "react";
import { State } from "country-state-city";
import Select from "react-select";

export interface StateProps {
  value: string;
  label: string;
}

interface StateDropDownProps {
  selectedStateISOCode?: string | null;
  onStateChange: (selectedOption: StateProps | null) => void;
}

const StateDropDown: React.FC<StateDropDownProps> = ({ selectedStateISOCode, onStateChange }) => {
  const [states, setStates] = useState<StateProps[]>([]);

  const formatStateForDropdown = (states: any) => {
    return states.map((state: any) => {
      return { value: state.isoCode, label: state.name }
    })
  }

  useEffect(() => {
    const fetchedStates = State.getStatesOfCountry('IN');
    const enhancedStates = formatStateForDropdown(fetchedStates);
    setStates(enhancedStates);
  }, []);

  return (
    <div className="form-group">
      <label htmlFor="selectState">
        <strong>Select State</strong>
      </label>
      <Select
        options={states}
        onChange={onStateChange}
        value={
          selectedStateISOCode ?
            formatStateForDropdown(State.getStatesOfCountry('IN'))
              .find((state: any) => state.value === selectedStateISOCode)
            : null
        }
        isSearchable={true}
        placeholder="Select a State" />
    </div>
  );
};

export default StateDropDown;